module.exports = __webpack_public_path__ + "static/media/ibopad1.61407e38.png";